import React, { useEffect, useState } from "react";
import TabItem from "./TabItem";
import styles from "./Tabs.module.scss";

const Tabs = props => {
  const { children } = props;
  const [tabHeader, setTabHeader] = useState([]);
  const [childContent, setChildConent] = useState({});
  const [active, setActive] = useState("");
  useEffect(() => {
    const headers = [];
    const childCnt = {};
    React.Children.forEach(children, element => {
      if (!React.isValidElement(element)) return;
      const { name } = element.props;
      headers.push(name);
      childCnt[name] = element.props.children;
    });
    setTabHeader(headers);
    setActive(headers[0]);
    setChildConent({ ...childCnt });
  }, []);

  const changeTab = name => {
    setActive(name);
  };

  return (
    <div className={`${styles.tabs} container`}>
      <ul className={styles.tabHeader}>
        {tabHeader.map(item => (
          <li
            onClick={() => changeTab(item)}
            key={item}
            className={item === active ? styles.active : ""}
          >
            {item}
          </li>
        ))}
      </ul>
      <div className={styles.tabContent}>
        {Object.keys(childContent).map(key => {
          if (key === active) {
            return (
              <div className='row' style={{ alignItems: "center" }} key={key}>
                {childContent[key]}
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  children: function (props, propName, componentName) {
    const prop = props[propName];

    let error = null;
    React.Children.forEach(prop, function (child) {
      if (child.type !== TabItem) {
        error = new Error(
          "`" + componentName + "` children should be of type `TabItem`."
        );
      }
    });
    return error;
  },
};

export default React.memo(Tabs);
